export { default as OpenInNewTabIcon } from '~icons/mdi/open-in-new';
